angular.module('tf.services')

    .factory('UrlEncodingService', ['HttpService', '$q',function (HttpService, $q) {
        var service = {};
        var cache = {};

        service.decrypt = function(url){
            var defer = $q.defer();
            if(cache[url]){
                defer.resolve(cache[url]);
            } else {
                HttpService.get("decode?url=" + url).then(function(res){
                    cache[url] = res.data;
                    defer.resolve(res.data);
                }, function(){
                    defer.reject();
                });
            }
            return defer.promise;
        };

        service.get = function(url){
            return cache[url];
        };


        return service;
    }])
;
